import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroWBCulturePeriodEndCP,
  selectMeteorologyAgroWBCulturePeriodStartCP,
  selectMeteorologyAgroWBCultureSelectedCultureCP,
  selectMeteorologyAgroWBCultureSelectedEmergencyDateCP,
  selectMeteorologyAgroWBCultureSelectedGroupCP,
  selectMeteorologyAgroWBCultureSelectedLocationCP,
  selectMeteorologyAgroWBCultureSelectedSoilCP,
} from 'redux/reducers/meteorologyAgroWBCultureReducer';
import { WBCultureDVGraphParams } from 'types/Meteorology/Agro/WaterBalanceCulture/DetailedView/getGraph';

export default function useParams() {
  const groupId = useSelector(selectMeteorologyAgroWBCultureSelectedGroupCP);
  const locationId = useSelector(selectMeteorologyAgroWBCultureSelectedLocationCP);
  const soilId = useSelector(selectMeteorologyAgroWBCultureSelectedSoilCP);
  const cultureId = useSelector(selectMeteorologyAgroWBCultureSelectedCultureCP);
  const emergencyDate = useSelector(selectMeteorologyAgroWBCultureSelectedEmergencyDateCP);
  const startDate = useSelector(selectMeteorologyAgroWBCulturePeriodStartCP);
  const endDate = useSelector(selectMeteorologyAgroWBCulturePeriodEndCP);

  const params: WBCultureDVGraphParams | undefined = useMemo(() => {
    const p = {
      groupId,
      locationId,
      soilId,
      cultureId,
      emergencyDate,
      startDate,
      endDate: endDate || startDate,
    };

    return (
      p.groupId !== undefined
      && p.locationId !== undefined
      && p.cultureId !== undefined
      && p.emergencyDate !== undefined
      && p.startDate !== undefined
      && p.endDate !== undefined
    ) ? p : undefined;
  }, [
    groupId,
    locationId,
    soilId,
    cultureId,
    emergencyDate,
    startDate,
    endDate,
  ]);

  return params;
}
